import {
  Outlet,
  createRootRouteWithContext,
  HeadContent,
  useNavigate
} from '@tanstack/react-router';
import { RouterProvider } from 'react-aria-components';
import { TanStackRouterDevtools } from '@tanstack/react-router-devtools';
import { ToastProvider } from '@heroui/react';
import {
  useGroupAnalytics,
  useIdentifyAnalytics,
  usePageAnalytics
} from '@rhino-project/ui-heroui';
import { RhinoContextType } from '@rhino-project/core';
import { getRhinoConfig } from '@rhino-project/core/config';
import { useIdentifyRollbar } from '../lib/rollbar';
import { ModeProvider } from '../contexts/ModeProvider';

interface AppRouterContext {
  rhino: RhinoContextType;
}

export const Route = createRootRouteWithContext<AppRouterContext>()({
  head: () => ({
    meta: [{ title: getRhinoConfig().appName }]
  }),
  component: RouteComponent
});

function RouteComponent() {
  const navigate = useNavigate();
  useIdentifyAnalytics();
  useGroupAnalytics();
  usePageAnalytics();
  useIdentifyRollbar();

  return (
    <RouterProvider navigate={(href) => navigate({ to: href as string })}>
      <ModeProvider>
        <HeadContent />
        <ToastProvider />
        <div className="h-dvh">
          <Outlet />
        </div>
        <TanStackRouterDevtools />
      </ModeProvider>
    </RouterProvider>
  );
}
